import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Problem } from "@/components/site/Problem";
import { Solution } from "@/components/site/Solution";
import { Products } from "@/components/site/Products";
import { WhyPoodles } from "@/components/site/WhyPoodles";
import { HowToUse } from "@/components/site/HowToUse";
import { Trust } from "@/components/site/Trust";
import { Waitlist } from "@/components/site/Waitlist";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <main className="relative bg-[#FAF7F2]">
      <Nav />
      <Hero />
      <Marquee />
      <Problem />
      <Solution />
      <Products />
      <WhyPoodles />
      <HowToUse />
      <Trust />
      <Waitlist />
      <Footer />
    </main>
  );
}
